import React from 'react';
import { useTheme } from 'styled-components';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';
import { useDesignVariant } from '../designVariantContext';

export const CurrentAccountBadge: React.FC = () => {
  const theme = useTheme();
  const variant = useDesignVariant();

  return (
    <Badge
      variant={variant}
      size="small"
      bgColor={variant ? theme.token.next.palette.blue50 : theme.token['blue.2']}
      borderColor={variant ? undefined : theme.token.colorBorderSecondary}
      icon={
        <FontAwesomeIcon
          icon={regular('link-horizontal')}
          color={variant ? theme.token.next.palette.grey700 : theme.token.colorPrimaryBase}
        />
      }
      label={
        <SmallText
          color={variant ? theme.token.next.palette.grey700 : theme.token.colorPrimaryText}
          fontWeight={500}
        >
          Current
        </SmallText>
      }
    />
  );
};
